import React from 'react';
import styles from './style.module.css';

const HeaderBigEllipse = () => (
  <svg width="86" height="42" viewBox="0 0 86 42" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M43 -1.93511e-06C66.7482 -8.97039e-07 86 -5.55179e-08 86 -5.55179e-08C86 23.196 66.7482 42 43 42C19.2518 42 8.21951e-07 23.196 1.83588e-06 -3.8147e-06C1.83588e-06 -3.8147e-06 19.2518 -2.97318e-06 43 -1.93511e-06Z" className={styles.effectFill}/>
  </svg>  
);

export default HeaderBigEllipse;